import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { IPoLineItems } from 'src/types/PoLineItems';
import { IPostBody } from 'src/types/PostBody';
import axiosInstance from 'src/utils/axios';

export interface PoLineItemsResponse {
  items: IPoLineItems[];
  totalRecords: number;
}

async function fetchPoLineItems(poId: number, postBody: IPostBody): Promise<PoLineItemsResponse> {
  const response = await axiosInstance.post<PoLineItemsResponse>(
    api.getPoLineItems(poId),
    postBody
  );
  return response.data;
}

export interface UsePoLineItemsQueryOptions {
  poId: number;
  postBody: IPostBody;
  enabled?: boolean;
}

export function usePoLineItemsQuery({
  poId,
  postBody,
  enabled = true,
}: UsePoLineItemsQueryOptions) {
  return useQuery<PoLineItemsResponse>({
    queryKey: queryKeys.po.lineItems(poId, postBody),
    queryFn: () => fetchPoLineItems(poId, postBody),
    enabled: Boolean(poId) && enabled,
  });
}
